import { motion } from "framer-motion";
import { Storefront, Table, Truck, BeerBottle, Martini, Drop, Snowflake } from "@phosphor-icons/react";
import { IMAGES } from "../data";
import { useLang } from "../i18n/LanguageContext";

const ICONS = [Storefront, Table, BeerBottle, Truck, Martini, Drop, Snowflake];

export default function Equipment() {
  const { t } = useLang();
  const e = t.equipment;
  return (
    <section id="equipment" data-testid="equipment-section" className="py-24 sm:py-32 bg-white border-y border-gray-200">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-4">
            <span className="font-accent text-xs tracking-[0.2em] uppercase font-bold text-[#4a90d9]">
              {e.overline}
            </span>
            <h2 className="font-heading text-3xl sm:text-5xl font-bold tracking-tight text-[#0A0D1F] mt-4">
              {e.title}
            </h2>
            <p className="text-base sm:text-lg text-[#5C6479] mt-5 leading-relaxed">{e.subtitle}</p>
            <div className="mt-8 overflow-hidden rounded-2xl border border-gray-200">
              <img src={IMAGES.equipment} alt={e.title} className="w-full h-64 object-cover" />
            </div>
          </div>

          <div className="lg:col-span-8 grid sm:grid-cols-2 gap-4">
            {e.items.map((item, i) => {
              const Icon = ICONS[i % ICONS.length];
              return (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: (i % 4) * 0.08 }}
                  data-testid={`equipment-item-${i}`}
                  className="group rounded-2xl border border-gray-200 bg-[#F8F9FB] p-6 transition-[transform,border-color,background-color] duration-300 hover:-translate-y-1 hover:border-[#4a90d9] hover:bg-white"
                >
                  <div className="w-12 h-12 rounded-xl bg-[#1e2a6e] flex items-center justify-center mb-4 group-hover:bg-[#4a90d9] transition-colors duration-300">
                    <Icon size={26} weight="duotone" className="text-white" />
                  </div>
                  <h3 className="font-heading text-lg font-bold text-[#0A0D1F]">{item.name}</h3>
                  <p className="text-sm text-[#5C6479] mt-2 leading-relaxed">{item.desc}</p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
